import { useAtom } from "jotai";
import { useItemsFilter } from "../../_helper/actions/app/items";
import { ApiEndPoint } from "../../_helper/constant/api-types";
import { clinicAtom } from "../../_helper/constant/constant-atom";
import CuDropdown from "../../common_component/component/CuDropdown";
import InputField from "../../common_component/component/InputField";
import "../css/PaymentVoucher.css";
import { useEffect, useRef, useState } from "react";
import moment from "moment";
import CustomButton from "../../common_component/component/CustomButton";
import {
  useCreateItem,
  useSecureUpdateItem,
} from "../../_helper/actions/mutation/items";
import { useNavigate } from "react-router-dom";
import { VIEW_ICON } from "../../cufront-assets/icons/Icons";
import { toast } from "react-toastify";
import CuScreenLoader from "../../common_component/component/CuScreenLoader";

const tableCols = [
  { id: 1, label: "Invoice number" },
  { id: 2, label: "Date" },
  { id: 3, label: "Amount" },
  { id: 4, label: "Payment Recieved" },
  { id: 5, label: "Recieving Now" },
];

const PaymentVoucher = ({ mode, id }) => {
  const [clinic] = useAtom(clinicAtom);
  const [options, setOptions] = useState({
    customer: [],
    payment: [],
  });
  const [searchInput, setSearchInput] = useState("");
  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({
    customer: null,
    transactionId: "",
    amountRecieved: "",
    date: "",
    type: 1,
    totalReceivable: "",
  });
  const submitBtnRef = useRef(null);
  const navigate = useNavigate();

  const queryForViewData = `?action=getBillingPaymentVoucher&frontend=True&clinic_id=${clinic?.id}&id=${id}`;
  const { data: viewData, isLoading } = useItemsFilter(
    ApiEndPoint.BILLING_PAYMENT_VOUCHER,
    queryForViewData,
    mode === "view" && id ? true : false
  );

  useEffect(() => {
    if (viewData) {
      setTableData(viewData?.distributed_payment || []);
      setFormData({
        customer: viewData?.customer_id,
        transactionId: viewData?.transaction_id,
        amountRecieved: viewData?.amount_recieved,
        date: moment(viewData?.transaction_date).format("YYYY-MM-DD"),
        type: viewData?.type?.id,
        totalReceivable: viewData?.receivable_amount,
      });
      setOptions({
        customer: [
          {
            key: viewData?.customer_id?.id,
            value: viewData?.customer_id?.id,
            text: viewData?.customer_id?.institution_name,
          },
        ],
        payment: [
          {
            key: viewData?.type?.id,
            value: viewData?.type?.id,
            text: viewData?.type?.type,
          },
        ],
      });
    }
  }, [viewData]);

  const queryForPaymentOptions = `?action=getPaymentOptions&frontend=True&clinic_id=${clinic?.id}`;
  const { data: paymentOptions } = useItemsFilter(
    ApiEndPoint.PAYMENT_OPTIONS,
    queryForPaymentOptions,
    mode !== "view" ? true : false
  );

  const queryForCustomerData = `?action=getInstitutionCustomers&frontend=True&clinic_id=${clinic?.id}&institution_name__icontains=${searchInput}`;
  const { data: customerData } = useItemsFilter(
    ApiEndPoint.INSTITUTION_CUSTOMERS,
    queryForCustomerData,
    mode !== "view" && searchInput?.length > 0 ? true : false
  );

  const { data: openInvoices } = useItemsFilter(
    ApiEndPoint.BILLING_CREDIT_INVOICE,
    `?action=getBillingCreditInvoice&frontend=True&clinic_id=${clinic?.id}&customer_name=${formData?.customer?.name}`,
    mode !== "view" && formData?.customer ? true : false,
    "invoice"
  );

  useEffect(() => {
    if (openInvoices?.data && mode !== "view") {
      let totalReceivable = 0;
      const tableData = openInvoices?.data?.map((oinvc) => {
        // totalReceivable += oinvc?.pending_payment;
        totalReceivable +=
          Number(oinvc?.invoice_total) - Number(oinvc?.receive_payment);
        return {
          id: oinvc?.id,
          invoice_number: oinvc?.invoice_no,
          date: moment(oinvc?.invoice_date).format("DD/MM/YYYY"),
          amount: oinvc?.invoice_total,
          payment_recieved: oinvc?.receive_payment,
          recieving_now: "0",
          pending_payment:
            Number(oinvc?.invoice_total) - Number(oinvc?.receive_payment),
          payment: oinvc?.billing_credit_payment,
        };
      });
      setFormData((prev) => ({
        ...prev,
        totalReceivable,
      }));
      setTableData([...tableData].reverse());
    }
  }, [openInvoices]);

  useEffect(() => {
    if (paymentOptions && mode !== "view") {
      const options = paymentOptions?.map((poption) => ({
        key: poption?.id,
        value: poption?.id,
        text: poption?.type,
      }));
      setOptions((prev) => ({ ...prev, payment: options }));
    }
  }, [paymentOptions]);

  useEffect(() => {
    if (customerData && mode !== "view") {
      const options = customerData?.map((cdata) => ({
        key: cdata?.id,
        value: cdata?.id,
        text: cdata?.institution_name,
      }));
      setOptions((prev) => ({ ...prev, customer: options || [] }));
    }
  }, [customerData]);

  // Function to distribute the received amount among invoices
  const distributeReceivedAmount = () => {
    if (tableData.length === 0) return;
    let receivedAmount = Number(formData?.amountRecieved);
    let updatedTableData = [...tableData];
    let i = 0;
    while (i < updatedTableData?.length) {
      if (receivedAmount > updatedTableData[i]?.pending_payment) {
        updatedTableData[i].recieving_now =
          updatedTableData[i]?.pending_payment;
        receivedAmount =
          Number(receivedAmount) - Number(updatedTableData[i]?.pending_payment);
      } else {
        updatedTableData[i].recieving_now = receivedAmount;
        receivedAmount = 0;
      }
      i++;
    }
    return updatedTableData;
  };

  useEffect(() => {
    // Distribute received amount among invoices whenever receivedAmount or tableData changes
    const distributedAmounts = distributeReceivedAmount();

    if (distributedAmounts) {
      setTableData(distributedAmounts);
    }
  }, [formData?.amountRecieved]);

  const handleFormChange = (val, label) => {
    if (label === "customer") {
      const selectedCustomer = customerData?.find(
        (customer) => customer?.id === val
      );
      setFormData((prev) => ({
        ...prev,
        [label]: {
          id: selectedCustomer?.id,
          name: selectedCustomer?.institution_name,
        },
      }));
      return;
    }
    setFormData((prev) => ({ ...prev, [label]: val }));
  };

  const closeForm = () => {
    setFormData({
      customer: null,
      transactionId: "",
      amountRecieved: "0",
      date: "",
      type: "",
      totalReceivable: "",
    });
    setTableData([]);
    setSearchInput("");
    setOptions({
      customer: [],
      payment: [],
    });
    navigate("/new/invoice?option=paymentvoucher");
  };

  const updateInvoiceMutation = useCreateItem(
    ApiEndPoint.BILLING_CREDIT_INVOICE
  );

  const postPaymentVoucherMutation = useCreateItem(
    ApiEndPoint.BILLING_PAYMENT_VOUCHER
  );

  const handleBookRecipt = (e) => {
    e.preventDefault();
    //   {
    //     "action": "postBillingCreditPayment",
    //     "backend": "True",
    //     "clinic_id": 1,
    //     "billing_credit_payment": [
    //         {
    //             "status": "test",
    //             "sort": 10,
    //             "received_payment": 10,
    //             "transaction_details": "hgd",
    //             "transaction_date": "2024-04-05T10:29:59Z",
    //             "user_created": 1,
    //             "user_updated": 1,
    //             "payment_mode": 1,
    //             "credit_invoice": 2
    //         },
    //         {
    //             "status": "test 2",
    //             "sort": 10,
    //             "received_payment": 10,
    //             "transaction_details": "hgd",
    //             "transaction_date": "2024-04-05T10:29:59Z",
    //             "user_created": 1,
    //             "user_updated": 1,
    //             "payment_mode": 1,
    //             "credit_invoice": 2
    //         }
    //     ]
    // }

    const billing_credit_payment = [];
    tableData?.forEach((invc) => {
      if (Number(invc?.recieving_now) > 0) {
        // const billing_credit_payment = [
        // ...invc?.payment,
        // {
        //   status: "Paid",
        //   recieved_payment: invc?.recieving_now,
        //   transaction_date: formData?.date,
        //   transaction_details: formData?.transactionId,
        //   payment_mode: formData?.type,
        // },
        // {
        //   status: "Paid",
        //   received_payment: invc?.recieving_now,
        //   transaction_details: formData?.transactionId,
        //   transaction_date: formData?.date,
        //   payment_mode: formData?.type,
        //   credit_invoice: invc?.id,
        // },
        // ];
        // const recieved_payment =
        //   Number(invc?.payment_recieved) + Number(invc?.recieving_now);
        // const pending_payment = Number(invc?.amount) - Number(recieved_payment);
        billing_credit_payment.push(
          // id: invc?.id,
          // billing_credit_payment,
          // recieved_payment,
          // pending_payment,
          {
            status: "Paid",
            received_payment: invc?.recieving_now,
            transaction_details: formData?.transactionId,
            transaction_date: formData?.date,
            payment_mode: formData?.type,
            credit_invoice: invc?.id,
            sort: 1,
          }
        );
      }
    });

    // updateInvoiceMutation.mutate(
    //   {
    //     action: "postBillingCreditPayment",
    //     backend: "True",
    //     clinic_id: clinic?.id,
    //     billing_credit_payment,
    //   },
    //   {
    //     onSuccess: () => {
    //       closeForm();
    //     },
    //     onError: () => toast.error("something went wrong"),
    //   }
    // );

    const distributed_payment = [];
    tableData?.forEach((ele) => {
      if (Number(ele?.recieving_now > 0)) {
        distributed_payment.push({
          ...ele,
        });
      }
    });

    const paymentVoucherPayload = {
      action: "postBillingPaymentVoucher",
      backend: "True",
      clinic_id: clinic?.id,
      transaction_id: formData.transactionId,
      amount_recieved: formData.amountRecieved,
      transaction_date: moment(formData.date).format("YYYY-MM-DDTHH:mm:ss[Z]"),
      distributed_payment,
      receivable_amount: formData?.totalReceivable,
      customer_id: formData.customer?.id,
      type: formData.type,
      status: "test",
    };

    // const paymentVoucherPayload = {
    //   customer_id: formData.customer,
    //   transaction_id: formData.transactionId,
    //   amount_recieved: formData.amountRecieved,
    //   transaction_date: formData.date,
    //   type: formData.type,
    //   distributed_payment,
    //   receivable_amount: formData?.totalReceivable,
    // };

    postPaymentVoucherMutation.mutate(paymentVoucherPayload, {
      onSuccess: () => {
        updateInvoiceMutation.mutate(
          {
            action: "postBillingCreditPayment",
            backend: "True",
            clinic_id: clinic?.id,
            billing_credit_payment,
          },
          {
            onSuccess: () => {
              closeForm();
            },
            onError: () => toast.error("something went wrong"),
          }
        );
      },
      onError: () => toast.error("something went wrong"),
    });
  };

  return (
    <div className="cu-invoice-payment-voucher-main">
      <form
        className="cu-invoice-payment-voucher-form"
        onSubmit={handleBookRecipt}
      >
        <div className="cu-invoice-payment-voucher-input">
          <label>Customer</label>
          <CuDropdown
            options={options?.customer}
            searchable={true}
            onSearch={(val) => setSearchInput(val)}
            onChange={(val) => handleFormChange(val, "customer")}
            value={formData?.customer?.id}
            required={true}
            disabled={mode === "view" ? true : false}
          />
        </div>
        <div className="cu-invoice-payment-voucher-input">
          <InputField
            label="Transaction ID"
            type={"text"}
            value={formData?.transactionId}
            required={true}
            onChange={(e) => handleFormChange(e.target.value, "transactionId")}
            disabled={mode === "view" ? true : false}
          />
        </div>
        <div className="cu-invoice-payment-voucher-input">
          <InputField
            label="Amount Recieved (INR)"
            type={"number"}
            value={formData?.amountRecieved}
            required={true}
            onChange={(e) => handleFormChange(e.target.value, "amountRecieved")}
            disabled={mode === "view" ? true : false}
          />
        </div>
        <div className="cu-invoice-payment-voucher-input">
          <InputField
            label="Date"
            type={"date"}
            value={formData?.date}
            required={true}
            onChange={(e) => handleFormChange(e.target.value, "date")}
            disabled={mode === "view" ? true : false}
          />
        </div>
        <div className="cu-invoice-payment-voucher-input">
          <label>Type</label>
          <CuDropdown
            options={options.payment}
            value={formData?.type}
            required={true}
            onChange={(val) => handleFormChange(val, "type")}
            disabled={mode === "view" ? true : false}
          />
        </div>
        <button
          type="submit"
          style={{ display: "none" }}
          ref={submitBtnRef}
          disabled={mode === "view" ? true : false}
        ></button>
      </form>
      <div className="cu-invoice-payment-voucher-table-cont">
        <div className="cu-invoice-payment-voucher-total">
          <div className="cu-invoice-payment-voucher-list-text">
            List of Open Invoices
          </div>
          <div className="cu-invoice-payment-voucher-list-amount">
            Total Receivable Amount: <span>{formData?.totalReceivable}</span>
          </div>
        </div>
        <div className="cu-invoice-payment-voucher-table">
          <table>
            <thead className="cu-invoice-voucher-header">
              <tr>
                {tableCols.map((tcol) => (
                  <th key={tcol?.id}>{tcol?.label}</th>
                ))}
                {/* <th>Action</th> */}
              </tr>
            </thead>
            <tbody>
              {tableData?.map((tdata, idx) => {
                return (
                  <tr key={idx}>
                    <td>{tdata?.invoice_number}</td>
                    <td>{tdata?.date}</td>
                    <td>{tdata?.amount}</td>
                    <td>{tdata?.payment_recieved}</td>
                    <td style={{ width: "100px", paddingRight: "10px" }}>
                      <InputField
                        value={tdata?.recieving_now}
                        disabled={mode === "view" ? true : false}
                      />
                    </td>
                    {/* {Object.keys(tdata)?.map((key, colIdx) => {
                      if (key === "recieving_now") {
                        return (
                          <td key={colIdx} style={{ width: "100px" }}>
                            <InputField
                              value={tdata[key]}
                              disabled={mode === "view" ? true : false}
                            />
                          </td>
                        );
                      }
                      return (
                        key !== "pending_payment" &&
                        key !== "id" &&
                        key !== "payment" && <td key={colIdx}>{tdata[key]}</td>
                      );
                    })} */}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="cu-invoice-voucher-btns">
          <CustomButton
            color={"white"}
            className={"cu-invoice-voucher-btn"}
            onClick={() => navigate("/new/invoice?option=paymentvoucher")}
          >
            {mode === "view" ? "Close" : "Cancel"}
          </CustomButton>
          {mode !== "view" && (
            <CustomButton
              color={"#EBF8EC"}
              className={"cu-invoice-voucher-btn"}
              onClick={() => submitBtnRef.current.click()}
              disabled={mode === "view" ? true : false}
              loading={
                updateInvoiceMutation.isLoading ||
                postPaymentVoucherMutation.isLoading
              }
            >
              Book Recipt
            </CustomButton>
          )}
        </div>
      </div>
      {isLoading && <CuScreenLoader />}
    </div>
  );
};

export default PaymentVoucher;
